import React from "react";
import { publicApi } from "@/lib/api";
import { FlaskConical } from "lucide-react";

/**
 * Franja de entorno: solo aparece cuando NO estamos en producción.
 * El objetivo es que nadie confunda el servidor de QA con el productivo
 * (el cliente va a tener los dos publicados en paralelo).
 */
export default function EnvBanner() {
  const [env, setEnv] = React.useState(null);
  const [hidden, setHidden] = React.useState(() => sessionStorage.getItem("aipos_env_banner_hidden") === "1");
  const ref = React.useRef(null);

  React.useEffect(() => {
    publicApi.get("/environment").then((r) => setEnv(r.data)).catch(() => {});
  }, []);

  // La caja ocupa toda la pantalla: le avisamos cuánto alto se lleva esta franja
  // para que COBRAR no quede fuera de la vista en tablets.
  React.useEffect(() => {
    const h = ref.current ? `${ref.current.offsetHeight}px` : "0px";
    document.documentElement.style.setProperty("--env-banner-h", h);
    return () => document.documentElement.style.setProperty("--env-banner-h", "0px");
  });

  if (!env?.show_banner || hidden || window.location.pathname.startsWith("/movil")) return null;

  return (
    <div
      ref={ref}
      data-testid="env-banner"
      className="sticky top-0 z-[90] flex items-center justify-center gap-2 px-4 py-1.5 text-[11px] font-bold tracking-wide text-amber-950 bg-gradient-to-r from-amber-300 via-amber-400 to-amber-300"
      style={{ backgroundImage: "repeating-linear-gradient(45deg, rgba(0,0,0,0.06) 0 10px, transparent 10px 20px), linear-gradient(90deg, #fcd34d, #fbbf24, #fcd34d)" }}
    >
      <FlaskConical className="w-3.5 h-3.5 shrink-0" />
      <span className="uppercase">{env.label}</span>
      <span className="font-normal opacity-80 hidden sm:inline">
        · los datos de acá no son reales
        {env.allow_simulated_payments ? " · cobros simulados activos" : ""}
      </span>
      <button
        data-testid="env-banner-hide"
        onClick={() => { sessionStorage.setItem("aipos_env_banner_hidden", "1"); setHidden(true); }}
        className="ml-2 underline underline-offset-2 font-semibold opacity-70 hover:opacity-100"
      >
        ocultar
      </button>
    </div>
  );
}
